// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_BuscarOrcamentosParaCompromissoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /orcamentos/buscar_orcamentos_para_compromisso
 *
 * Validates search request for finding orcamentos to link to compromissos.
 */
import { registerContract } from './validate'

export interface Orcamentos_BuscarOrcamentosParaCompromissoInput {
search: string
}

registerContract('Orcamentos_BuscarOrcamentosParaCompromissoInput', {
  search: { type: 'string',  required: true },
})
